/* eslint-disable max-lines */
 
/* eslint-disable no-unused-vars */
import $ from 'jquery';
import { datepicker } from '../../smartpak/datepicker.js';
import { tooltipProxy as tooltip } from '../../smartpak/tooltipproxy.js';

const wizardCategoryTooltips = {
    'Age': 'Not intended to be used for horses under 2 years of age. Please consult your veterinarian.',
    'Gender':
        'Not intended to be used for mares that are pregnant, lactating or intended for breeding. Please consult your veterinarian.',
    'Diet':
        'Types of grass hays include Orchard Grass, Timothy, Brome, Blue Grass, Coastal Bermuda, Foxtail, Fescue, etc. Types of legumes include Clover, Lespedeza, Vetch.',
    'Hoof Soreness':
        'Signs include a short, choppy stride (especially on hard surfaces or a decline), stumbling, shuffling or stiffness, and/or discomfort that is more pronounced immediately before or after hoof trimming.'
},
    miniWizardCategoryToolTips = {
        Age: 'Not intended to be used for horses under 2 years of age. Please consult your veterinarian.'
    },
    miniWizardAnswerToolTips = {
        'Ration balancer':
            "A concentrated feedstuff (usually a pellet) designed to balance a forage-only diet by providing protein, vitamins, and minerals, but not a significant source of calories; ideal for easy keepers. Examples: Purina Nature's Essentials&reg; Enrich 32&reg;, Nutrena Empower™ Balance",
        'Fortified grain':
            'A manufactured feed that includes added, guaranteed levels of protein, vitamins, and minerals; common types include pelleted and sweet feeds. Examples: Purina&reg; Omolene #100&reg;, Triple Crown 14% Performance, Nutrena SafeChoice Original',
        'Complete feed':
            "A manufactured feed that combines grain and roughage; designed to partially or completely replace a horse's forage, usually due to dental problems, or because quality hay is not available. Examples: Purina&reg; Equine Senior&reg;, Triple Crown&reg; Complete",
        'Whole grains':
            'A cereal grain that has not been fortified with additional nutrients; may be processed by cracking, crimping, rolling, or heating. Examples: oats, corn, barley'
    },
    CLASSES = {
        hide: 'w-js-hide',
        category: 'w-cat',
        categoryTitle: 'w-cat-title',
        catHasHint: 'w-cat-hint',
        question: 'w-question',
        alert: 'w-alert-con',
        toolTip: 'hint'
    },
    allowedFormSelectors = 'select, input:radio, input:text, input:checkbox',
    questionPrefix = 'Question_',
    answerPrefix = 'Answers_',
    findCategories = findByClassInContext(CLASSES.category),
    findCategoryTitle = findByClassInContext(CLASSES.categoryTitle),
    findQuestions = findByClassInContext(CLASSES.question),
    findAlerts = findByClassInContext(CLASSES.alert);

// cache a few elements
let $form, $categoryAlertCon, $enterHorseCon, $horseNameSelect, $horseNameTextBox, $doc, windowWidth;

function hasRecipientForm() {
    return $enterHorseCon.length > 0;
}

function isMiniWizard() {
    return hasRecipientForm();
}

function isEmpty(element) {
    return !element.value.length > 0;
}

function isRestrictedName(name) {
    return name.trim().toLowerCase() === 'me';
}

function isRecipientFormValid() {
    var validFilledInCount = 1;
    return (
        $enterHorseCon.find('input:text, select').filter(function (index, elem) {
            return !isEmpty(elem) && !isRestrictedName(elem.value);
        }).length === validFilledInCount
    );
}

// returns a new function that returns elements within a provided context with a class.

function findByClassInContext(className) {
    return function ($context) {
        return ($context || $doc).find('.' + className);
    };
}

function getElemById(id, $context) {
    return ($context || $doc).find('#' + id);
}

function addToolTipIcon($elem) {
    if ($elem) {
        $elem.append('<a class="' + CLASSES.toolTip + '">?</a>');
    }
}

function fadeOut(box, callback) {
    $(box).fadeOut(500);
    // bt plugin says that you should call callback on showTip/hideTip functions
    if (callback && typeof callback === 'function') {
        callback();
    }
}

function fadeIn(box, callback) {
    $(box)
        .delay(100)
        .fadeIn(500);
    // bt plugin says that you should call callback on showTip/hideTip functions
    if (callback && typeof callback === 'function') {
        callback();
    }
}

function addToolTip($elem, toolTipText) {
    tooltip($elem, {
        width: windowWidth > 480 ? 350 : 250,
        trigger: 'hover',
        content: toolTipText
    });
}

function addToolTips($elems, toolTipObj, findLabelFunc) {
    $elems.each(function (index, elem) {
        var $this = $(elem),
            $label = $.isFunction(findLabelFunc) ? findLabelFunc($this) : $this,
            labelText = $label.text();

        if (labelText in toolTipObj) {
            $this.addClass(CLASSES.catHasHint);
            addToolTipIcon($this);
            addToolTip($this.find('.' + CLASSES.toolTip), toolTipObj[labelText]);
        }
    });
}

function initializeToolTips() {
    var categoryToolTips = wizardCategoryTooltips;

    if (isMiniWizard()) {
        addToolTips(findQuestions().find('> div'), miniWizardAnswerToolTips, function ($elem) {
            return $elem.find('> label');
        });

        categoryToolTips = miniWizardCategoryToolTips;
    }

    addToolTips(findCategoryTitle(), categoryToolTips);
}

function clearAlerts() {
    hideQuestionAlert($form);
    hideCategoryAlerts();
    clearRecipientError();
}

function showQuestionAlert($context) {
    if ($context) {
        $context.addClass(CLASSES.alert);
    }
}

function hideQuestionAlert($context) {
    if ($context) {
        findAlerts($context).removeClass(CLASSES.alert);
    }
}

function showCategoryAlerts(failedCategoryTitles) {
    if (!failedCategoryTitles.length) {
        return;
    }

    $categoryAlertCon.removeClass(CLASSES.hide);
}

function hideCategoryAlerts() {
    $categoryAlertCon.addClass(CLASSES.hide);
}

function findFormElements($context) {
    return $context && $context.find(allowedFormSelectors);
}

function findFormElementByName(name, $context) {
    return ($context || $doc).find('[name=' + name + ']');
}

function getNodeName($element) {
    return $element[0].nodeName.toUpperCase();
}

function getAnswerNameFromQuestionId(id) {
    return id.replace(questionPrefix, answerPrefix);
}

function getCategoryTitle($category) {
    return findCategoryTitle($category).text();
}

function freeTextTriggerIdMatchesValue(elementData, val) {
    return (
        elementData.freetexttriggerid &&
        elementData.freetextfieldname &&
        elementData.freetexttriggerid.toString() === val
    );
}

function enableSubmitButton($button) {
    if ($button.length) {
        $button.prop('disabled', false);
    }
}

function disableSubmitButton($button) {
    if ($button.length) {
        $button.prop('disabled', true);
    }
}

function isValidQuestion($question) {
    var nameAttrVal = getAnswerNameFromQuestionId($question[0].id),
        $answerElements = findFormElementByName(nameAttrVal, $question),
        $checkedRadio,
        ret = true,
        val,
        selectData;

    // ignore checkboxes.  Checkboxes don't follow the same
    // Question_[id] = Answers_[id] pattern as other question types.
    if (!$answerElements.length) {
        return ret;
    }

    // if length is 1 it is either a select or textbox
    if ($answerElements.length === 1) {
        val = $answerElements.val();

        if (getNodeName($answerElements) === 'SELECT' && val) {
            selectData = $answerElements.data();

            if (freeTextTriggerIdMatchesValue(selectData, val)) {
                ret = getElemById(selectData.freetextfieldname, $question).val() !== '';
            }
        } else {
            ret = false;
        }
    } else {
        // otherwise the elements are probably radio buttons
        $checkedRadio = $answerElements.filter(':checked');

        if ($checkedRadio.length) {
            selectData = $checkedRadio.data();
            val = $checkedRadio.val();

            if (freeTextTriggerIdMatchesValue(selectData, val)) {
                ret = getElemById(selectData.freetextfieldname, $question).val() !== '';
            }
        } else {
            ret = false;
        }
    }

    return ret;
}

function getFailedCategories($categories) {
    return $categories.filter(function (indx, category) {
        var $category = $(category),
            $questions = findQuestions($category).filter(':visible'),
            failedQuestionElements = [],
            categoryFailed = false;

        $.each($questions, function (indx, item) {
            if (!isValidQuestion($(item))) {
                showQuestionAlert($(item));
                categoryFailed = true;
            }
        });

        return categoryFailed;
    });
}

function validateForm(e) {
    e.preventDefault();

    // using e.target instead of this for $submitButton because of Possible strict violation
    var $submitButton = $(e.target),
        $loadingMessage = $('.progress-indicator'),
        $failedCategories,
        hasCategoryErrors = false,
        hasRecipientErrors = false;

    // prevent multiple clicks
    disableSubmitButton($submitButton);

    // clean up old alerts
    clearAlerts($form);

    $failedCategories = getFailedCategories(findCategories($form));

    if ($failedCategories.length) {
        showCategoryAlerts(
            $failedCategories.map(function (index, elem) {
                return getCategoryTitle($(elem));
            })
        );

        hasCategoryErrors = true;
    }

    if (hasRecipientForm()) {
        hasRecipientErrors = !isRecipientFormValid();
        if (hasRecipientErrors) {
            showQuestionAlert($enterHorseCon);
            showRecipientError();
        }
    }

    if (!hasCategoryErrors && !hasRecipientErrors) {
        fadeIn($loadingMessage);
        $form.trigger('submit');
    } else {
        enableSubmitButton($submitButton);
        $form.find('.' + CLASSES.alert + ':first select').focus();
        $('html, body').scrollTop($form.find('.' + CLASSES.alert + ':first').position().top);
    }
}

function clearRecipientError() {
    $categoryAlertCon
        .find('[data-valmsg-summary] ul > li.animal-name-error')
        .remove();
}

function showRecipientError() {
    $categoryAlertCon
        .removeClass(CLASSES.hide)
        .find('[data-valmsg-summary]')
        .removeClass('validation-summary-valid')
        .find('ul')
        .append('<li class="animal-name-error">Animal name is invalid.</li>');
}

function initializeFormValidation() {
    $form = $('#wizard-container form');
    $categoryAlertCon = $('.w-validation-error');
    $enterHorseCon = $('#enterHorseCon');
    $form.on('click', '.wizard-submit-button', validateForm);
}

function freeTextEventHandler(event, $trigger, triggerId, $freeText) {
    if ($trigger.length && $freeText.length) {
        $trigger.on(event, function (e) {
            if (e.target.value === triggerId) {
                $freeText.show();
            } else {
                $freeText.hide().val('');
            }
        });
    }
}

function wireUpFreeTextSelects() {
    var selects = $('select[data-freetextcontrol]');
    for (var i = 0; i < selects.length; i++) {
        var lstSelector = '#' + $(selects[i]).attr('data-freetextcontrol'),
            triggerId = $(selects[i]).attr('data-freetexttriggerid'),
            freeTextSelector = '#' + $(selects[i]).attr('data-freetextfieldname');
        freeTextEventHandler('change', $(lstSelector), triggerId, $(freeTextSelector));

        if ($(lstSelector).val() === triggerId) {
            $(freeTextSelector).show();
        }
    }
}

function wireUpFreeTextRadios() {
    var radios = $('input[data-freetextcontrol]');
    for (var i = 0; i < radios.length; i++) {
        var radioSelector =
            'input[id=' +
            $(radios[i]).attr('data-freetextcontrol') +
            "][value='" +
            radios[i].getAttribute('value') +
            "']",
            triggerId = $(radios[i]).attr('data-freetexttriggerid'),
            freeTextSelector = '#' + $(radios[i]).attr('data-freetextfieldname');
        freeTextEventHandler('click', $(radioSelector), triggerId, $(freeTextSelector));
    }
}

function wireUpDatePickers() {
    var datepickers = $('input[data-datepickercontrol]');
    for (var i = 0; i < datepickers.length; i++) {
        var dateSelector = "input[id='" + $(datepickers[0]).attr('data-datepickercontrol') + "']";
        datepicker(document.querySelector(dateSelector));
    }
}

function isSelectTag($elem) {
    return getNodeName($elem) === 'SELECT';
}

function isRadioTag($elem) {
    return $elem.attr('type') === 'radio';
}

function hideAndResetDependents($dependents) {
    $.each($dependents, function (indx, dependent) {
        var $dependent = $(dependent),
            $selectControlSelector,
            $questionControlContainer,
            selectId,
            data = $dependent.data();

        if (data.dependentOnControl) {
            selectId = data.dependentOnControl;
            $selectControlSelector = getElemById(answerPrefix + selectId);
            $questionControlContainer = getElemById(questionPrefix + selectId);
            data = $selectControlSelector.data();

            // recursive call to hide/clear dependent questions
            hideAndResetDependents($("div[data-dependent-on-question='" + answerPrefix + selectId + "']"));

            if ($selectControlSelector.length) {
                if (
                    data &&
                    data.freetexttriggerid &&
                    data.freetexttriggerid === parseInt($selectControlSelector.val(), 10)
                ) {
                    // 10 as the radix will allow numbers with leading zeros.
                    getElemById(data.freetextfieldname)
                        .hide()
                        .val('');
                }

                if (isSelectTag($selectControlSelector)) {
                    // reset selected option to the first option
                    $selectControlSelector.find('option:first').attr('selected', true);
                }
            }

            $($questionControlContainer)
                .find('input[type=radio]:checked')
                .prop('checked', false);
            $($questionControlContainer)
                .find('input[type=checkbox]:checked')
                .prop('checked', false);

            $($questionControlContainer).hide();
        }
    });
}

function showDependents($dependents) {
    $.each($dependents, function (indx, dependent) {
        var $dependent = $(dependent),
            data = $dependent.data();

        if (data.dependentOnControl) {
            getElemById(questionPrefix + data.dependentOnControl).show();
        }
    });
}

function manageDependents(prerequisite, value) {
    // hide dependents & unselect
    hideAndResetDependents($("div[data-dependent-on-question='" + prerequisite + "']"));

    // show dependent = value
    showDependents($('[data-dependent-on-answer~=' + value + ']'));
}

function wireUpDependencyHandlers(prerequisite) {
    var $element = $('[name="' + prerequisite + '"]'),
        nodeName;
    if ($element.length) {
        nodeName = $element[0].nodeName.toLowerCase();

        if (nodeName === 'input') {
            $element.on('click', function (e) {
                manageDependents(prerequisite, e.target.value);
            });
        } else if (nodeName === 'select') {
            $element.on('change', function (e) {
                manageDependents(prerequisite, e.target.value);
            });
        }
    }
}

function showDependentQuestionByInputName(name, qContainer) {
    var $checked = $('input[name=' + name + ']').filter(':checked'),
        $div,
        data,
        question,
        $container;

    $div = $checked.length
        ? $('div[data-dependent-on-answer=' + $checked.val() + ']')
        : $('div[data-dependent-on-control=' + name + ']').eq(0);

    if ($div.length) {
        data = $div.data();
        question = getElemById(questionPrefix + data.dependentOnControl);
        $container = $('#' + qContainer);

        if ($container.length) {
            $(question).show();
        } else {
            $container.show();
        }
    }
}

function hideDependentQuestionByControl(controlId, qContainer) {
    var question = getElemById(questionPrefix + controlId),
        $container = $('#' + qContainer);

    if ($container.length) {
        $(question).hide();
    } else {
        $container.hide();
    }
}

function wireUpDependencies() {
    $('[data-dependent-on-question]')
        .filter(function (index, elem) {
            return $(elem).data().dependentOnQuestion;
        })
        .each(function (index, elem) {
            var data = $(elem).data(),
                question = data.dependentOnQuestion,
                answers = data.dependentOnAnswer.toString().split(' '),
                questionContainer = question.replace(/Answers/gi, 'Question');

            if (question) {
                hideDependentQuestionByControl(data.dependentOnControl, questionContainer);

                $(answers).each(function (i, answerId) {
                    var $answer = $('#' + answerId),
                        dependent = false;

                    if (!$answer.length) {
                        $answer = $('#' + question);
                    }

                    $('#' + answerPrefix + data.dependentOnControl).each(function (i, val) {
                        var num = $(val).attr('data-dependent-on-answer');

                        if (num === answerId && !$('#' + questionContainer).length) {
                            dependent = true;
                            return false;
                        }

                        return true;
                    });

                    if (
                        dependent ||
                        (isSelectTag($answer) && $answer.val() === answerId) ||
                        (isRadioTag($answer) && $answer.prop('checked'))
                    ) {
                        showDependentQuestionByInputName(data.dependentOnControl, questionContainer);
                    }
                });

                wireUpDependencyHandlers(question);
            }
        });
}

export default function questionaire() {
    $doc = $(document);
    windowWidth = $(window).width();
    wireUpFreeTextSelects();
    wireUpFreeTextRadios();
    wireUpDatePickers();
    wireUpDependencies();
    initializeFormValidation();
    initializeToolTips();
}
